import { defineMessage } from 'services/localization';

export const messages = {
    headerText: defineMessage('audit_trail'),
    expandButtonText: defineMessage('count_plural_one_show_event_other_show_events'),
};
